import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// ---------------------------------------------------------------------------
// State — drives the global floating recorder bar
// ---------------------------------------------------------------------------

export interface FloatingRecorderState {
    /** Whether a recording session is currently active (bar is visible) */
    isActive: boolean;
    /** Employee number of the logged-in TL (caller) */
    callerId: string | number;
    /** Employee number of the associate being coached (callee) */
    calleeId: string | number;
    /** Display name of the associate — shown in the bar label */
    associateName: string;
}

const initialState: FloatingRecorderState = {
    isActive: false,
    callerId: '',
    calleeId: '',
    associateName: '',
};

export interface StartRecordingPayload {
    callerId: string | number;
    calleeId: string | number;
    associateName: string;
}

const floatingRecorderSlice = createSlice({
    name: 'floatingRecorder',
    initialState,
    reducers: {
        /** Called from any module when user triggers "Side by Side" recording */
        startFloatingRecording(state, action: PayloadAction<StartRecordingPayload>) {
            state.isActive = true;
            state.callerId = action.payload.callerId;
            state.calleeId = action.payload.calleeId;
            state.associateName = action.payload.associateName;
        },
        /** Called when user clicks "End Recording" on the floating bar */
        stopFloatingRecording(state) {
            state.isActive = false;
        },
        /** Full reset — called after the post-stop modal is dismissed */
        resetFloatingRecording() {
            return initialState;
        },
    },
});

export const {
    startFloatingRecording,
    stopFloatingRecording,
    resetFloatingRecording,
} = floatingRecorderSlice.actions;

export default floatingRecorderSlice.reducer;

// Selectors
export const selectFloatingRecorder = (state: any) => state.floatingRecorder;
export const selectFloatingRecorderIsActive = (state: any): boolean => state.floatingRecorder.isActive;
